import { Typography } from "@mui/material";
import { Box, Card, Grid } from "@mui/material";
import {
	AccessTime,
	CloudDownload,
	Description,
	Info,
	NotificationsActiveRounded,
	ReportProblem,
	Videocam,
} from "@mui/icons-material";
import React from "react";
import { Link } from "react-router-dom";
import { styled } from "@mui/material";
import theme from "../../../theme";

const CustomLink = styled(Link)(({ theme }) => ({
	textDecoration: "none",
	"& img": {
		transition: ".2s",
	},
	"& .MuiAvatar-root": {
		transition: ".2s",
	},
	"& :hover": {
		"& img": {
			transform: "scale(1.1)",
		},
		"& .MuiAvatar-root": {
			borderColor: theme.palette.admin.text,
		},
	},
}));

const ButtonItem = (props) => {
	const { item } = props;

	const renderIcon = () => {
		switch (item.icon) {
			case "campana":
				return (
					<NotificationsActiveRounded
						style={{
							fontSize: 60,
							fill: theme.palette.third.main,
							paddingRight: 20,
						}}
					/>
				);
			case "descarregar":
				return (
					<CloudDownload
						style={{
							fontSize: 60,
							fill: theme.palette.third.main,
							paddingRight: 20,
						}}
					/>
				);
			case "document":
				return (
					<Description
						style={{
							fontSize: 60,
							fill: theme.palette.third.main,
							paddingRight: 20,
						}}
					/>
				);
			case "rellotge":
				return (
					<AccessTime
						style={{
							fontSize: 60,
							fill: theme.palette.third.main,
							paddingRight: 20,
						}}
					/>
				);
			case "info":
				return (
					<Info
						style={{
							fontSize: 60,
							fill: theme.palette.third.main,
							paddingRight: 20,
						}}
					/>
				);
			case "alerta":
				return (
					<ReportProblem
						style={{
							fontSize: 60,
							fill: theme.palette.third.main,
							paddingRight: 20,
						}}
					/>
				);
			case "video":
				return (
					<Videocam
						style={{
							fontSize: 60,
							fill: theme.palette.third.main,
							paddingRight: 20,
						}}
					/>
				);
			default:
				break;
		}
	};

	return (
		<Grid item size={6} key={item.id}>
			<CustomLink to={`/admin/buttons/${item.id}`}>
				<Card>
					<Box display="flex" p={3} alignItems="center">
						{renderIcon()}
						<Box>
							<Typography variant="h4">{item.nom}</Typography>
							<Typography variant="body1">
								{item.subtitol}
							</Typography>
						</Box>
					</Box>
				</Card>
			</CustomLink>
		</Grid>
	);
};

export default ButtonItem;
